interface SpeakerInfo {
    speakerId: string;
    speed: number;
    audioCtrl?: string;
}
interface PromptSpeakerInfoMap {
    [promptId: string]: SpeakerInfo;
}
const PROMPT_SPEAKERINFO_MAP: PromptSpeakerInfoMap = {
    '398': {
        speakerId: '4146',
        speed: 2,
    },
    '421': {
        speakerId: '4149',
        speed: 2,
    },
    '429': {
        speakerId: '11100',
        speed: 2,
    },
    '426': {
        speakerId: '4146',
        speed: 2,
    },
    '425': {
        speakerId: '4146',
        speed: 2,
    },
    '427': {
        speakerId: '4149',
        speed: 2,
    },
    '415': {
        speakerId: '6588',
        speed: 2,
    },
    '412': {
        speakerId: '6588',
        speed: 2,
    },
    '399': {
        speakerId: '6593',
        speed: 2,
    },
    '400': {
        speakerId: '6593',
        speed: 2,
    },
    '423': {
        speakerId: '6510',
        speed: 2,
    },
    '422': {
        speakerId: '6598',
        speed: 2,
    },
    '442': {
        speakerId: '6510',
        speed: 2,
    },
    '416': {
        speakerId: '6595',
        speed: 2,
    },
    '455': {
        speakerId: '4149',
        speed: 2,
    },
    '457': {
        speakerId: '4156',
        speed: 2,
    },
    '424': {
        speakerId: '6598',
        speed: 2,
    },
    '450': {
        speakerId: '7009',
        speed: 2,
        audioCtrl: JSON.stringify({
            mid: 'paimeng',
        }),
    },
    '451': {
        speakerId: '7009',
        speed: 2,
        audioCtrl: JSON.stringify({
            mid: 'naxida',
        }),
    },
    '610': {
        speakerId: '7009',
        speed: 2,
        audioCtrl: JSON.stringify({
            mid: 'gongzishang',
        }),
    },
    '611': {
        speakerId: '7009',
        speed: 2,
        audioCtrl: JSON.stringify({
            mid: 'gongyuanzhi',
        }),
    },
};

export {PROMPT_SPEAKERINFO_MAP};
